import withLoader from "../../../components/layouts/WithLoader"
import { Snackbar } from "@material-ui/core";
import { Alert } from "@material-ui/lab";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import getCurrentUserId from "../../../reduxSaga/sagas/requests/currentUserId";
import DiscountService from "../../../services/DiscountService";
import Select from "react-select";
import makeAnimated from "react-select/animated";
import SocieteService from "../../../services/Societe";



const AddConditionCommercialTiersClient =({startLoading,stopLoading})=>{

  const animatedComponents = makeAnimated();

  const navigate = useNavigate();



  const [openErrorAlert, setOpenErrorAlert] = useState(false);
  const [errorAlertText, setErrorAlertText] = useState();
  const [openSuccessAlert, setOpenSuccessAlert] = useState(false);
  const [successAlertText, setSuccessAlertText] = useState();
  const [options, setOptions] = useState([]);
  const [optionsCondition, setOptionsCondition] = useState([]);

  const [idSociete, setIdSociete] = useState();
  const [idCC, setIdCC] = useState();

  const [selectedOption, setSelectedOption] = useState(null);
  const [selectedOptionCondition, setSelectedOptionCondition] = useState(null);


  useEffect(()=>{
    startLoading();
    SocieteService.getSocietesClients("CLIENT", "CLIENT", 1, 0)
      .then((response) => {
        if (response.data["vide"] !== undefined) {
          setOpenErrorAlert(true);
          setErrorAlertText("Erreur : "+response.data["vide"]);
        } else {
   
          const updatedOptions = response.data["Societe"].map((typeBill) => ({
            value: typeBill.id,
            label: typeBill.matricule+"-"+typeBill.title,
          }));
          setOptions([ ...updatedOptions]);
        }
      })
      .catch((error) => {
        setOpenErrorAlert(true);
        setErrorAlertText("Erreur : "+error)
      })
      .finally(() => {
        stopLoading();
      });

      DiscountService.allConditionsCommercialTiers(getCurrentUserId(), 1, 0)
      .then((response) => {
        if (response.data.success) {
          const updatedOptions = response.data.success.map((typeBill) => ({
            value: typeBill.id,
            label: typeBill.refCC+"-"+typeBill.nameCC,
          }));
          setOptionsCondition([ ...updatedOptions]);
        }
      })
      .catch((e) => {
        console.log("error in allDiscounts", e);
      })
      .finally(() => {
        stopLoading();
      });
  }, []);
 

  const onValidCCClientHandler = () => {

      let promotionCCAddModel = {
        idPartenairClient: idSociete,
        idUserCreation: getCurrentUserId(),
        idCCT:idCC
      };
      console.log("promotionCCAddModel", promotionCCAddModel);
      startLoading()
      DiscountService.addConditionCommercialTiersToPartnerClient(promotionCCAddModel)
      .then((response) => {
        console.log("response", response.data["success"]);
        if (response.data.success) {
          setOpenSuccessAlert(true);
          setSuccessAlertText("Enregistrement avec succées");
          setTimeout(() => {
            navigate(`/conditionscommercialsTiers`);
          }, 2000);
        } 
      })
      .catch((e) => {
          console.log("error in allDiscounts", e);
      }).finally(() => {
        stopLoading()
      })
    
  };
  const handleEroorClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenErrorAlert(false);
  };

  const handleSuccessClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenSuccessAlert(false);
  };
  const handleChange = (selectedOption) => {
    setSelectedOption(selectedOption);
    setIdSociete(selectedOption.value);
  };


  const handleConditionChange = (selectedOption) => {
    setSelectedOptionCondition(selectedOption);
    setIdCC(selectedOption.value);
  };
  return (
    <div className="content-wrapper" style={{ marginTop: "0" }}>
      <section className="content-header">
        <div className="container-fluid">
          <div className="row">
            <div className="col-md-6"></div>
            <div className="col-md-6">
              <ol class="breadcrumb float-sm-right">
                <li class="breadcrumb-item">Home</li>
                <li class="breadcrumb-item active">
                  Ajouter Condition Commercial
                </li>
              </ol>
            </div>
          </div>
        </div>
      </section>
      <section className="content ">
        <div className="container-fluid">
          <div className="row mb-2">
            <div className="col-sm-12">
              <div class="card ">
                <div className="card-header">
                  <h5 className="card-title"> Ajouter Condition Commercial</h5>
                </div>
                <div class="card-body">
                <div className="row">
                      <div className="form-group col-6 col-sm-6">
                        <div>
                          <label>Choisir le client</label>
                          <Select
                            value={selectedOption}
                            closeMenuOnSelect={true}
                            components={animatedComponents}
                            options={options}
                            onChange={handleChange}
                            defaultValue={selectedOption}
                            placeholder={"Tous"}
                          />
                        </div>
                      </div>
                      <div className="form-group col-6 col-sm-6">
                        <div>
                          <label>Choisir Condition commercial</label>
                          <Select
                            value={selectedOptionCondition}
                            closeMenuOnSelect={true}
                            components={animatedComponents}
                            options={optionsCondition}
                            onChange={handleConditionChange}
                            defaultValue={selectedOptionCondition}
                            placeholder={"Tous"}
                          />
                        </div>
                      </div>
                      </div>

                
                 
                </div>
                <div class="card-footer" style={{ marginTop: "1%" }}>
                  <button
                    class="btn btn-dark float-right"
                    style={{ marginTop: "1%" }}
                    onClick={onValidCCClientHandler}
                  >
                    Confirmer
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <Snackbar
        open={openErrorAlert}
        autoHideDuration={2000}
        onClose={handleEroorClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
      >
        <Alert variant="filled" onClose={handleEroorClose} severity="error">
          {errorAlertText}
        </Alert>
      </Snackbar>

      <Snackbar
        open={openSuccessAlert}
        autoHideDuration={2000}
        onClose={handleSuccessClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
      >
        <Alert variant="filled" onClose={handleSuccessClose} severity="success">
          {successAlertText}
        </Alert>
      </Snackbar>
    </div>
  );

}
export default withLoader(AddConditionCommercialTiersClient);